<template>
    <app-layout title="Create Survey">
        <template v-slot:header>
            <h2 class="font-bold text-4xl dark:text-gray-200">
                New diagnostic
            </h2>
        </template>

        <div>
            <survey-editor :survey-types="$page.props.surveyTypes" />
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import SurveyEditor from "@/Components/SurveyEditor";

export default {
    components: {
        SurveyEditor,
        AppLayout,
    },
}
</script>
